import { FormControl, Validators } from '@angular/forms';
import { SharkifyAiSerivceService } from 'src/app/sharkify-ai-serivce.service';
import { Component, Inject, OnInit, ViewEncapsulation, EventEmitter, Output, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppComponent } from 'src/app/app.component';
import { PromoCode } from 'src/app/Models/PromoCodeResponse';
import { Dialog } from '@angular/cdk/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-plans',
  templateUrl: './plans.component.html',
  styleUrls: ['./plans.component.css']
})
export class PlansComponent implements OnInit {
  constructor(public service: SharkifyAiSerivceService, public router: Router,public app:AppComponent,public dialog: MatDialog,private toastr: ToastrService) { }

  issocial: boolean = true;
  isbrand: boolean = false;
  selectedPlan: string = '';
  selectedPlanPrice: number = 0;
  gstAmount: number = 0;
  totalAmount: number = 0;
  isMonthly: boolean = false;
  indexofplan: number = 0;
  showfeatures: boolean = true;
  selectedPlanIndex : number =1;
  voucherControl: FormControl= new FormControl('', [Validators.required, Validators.minLength(5)]);
  VoucherCode: FormControl= new FormControl('');
  DiscountAmount: number = 0;
  isVoucherValid: boolean = false;
  AppliedVouchers: string[] = [];
  isVoucherSectionOpen: boolean = false;
  AppliedCoupon: boolean = false;
  isCoupon: boolean = false;  
  couponname : string = "";
  Userid : any ;
  businessinfoid : any ;
  businessname : any;
  selectedbusiness : boolean = false;
  SocialMonthlypackages = [
    {
      image:'/assets/ignite_icon.png',
      packagename: 'IGNITE',
      price: 1999,
      originalPrice: 3999,
      frequency: '/ Month',
    },
    {      
      image: '/assets/boost_icon.png',
      packagename: 'BOOST',
      price: 2599,
      originalPrice: 4999,
      frequency: '/ Month',
    },
    {      
      image: '/assets/viral_icon.png',
      packagename: 'VIRAL',
      price: 2999,
      originalPrice: 5999,
      frequency: '/ Month',
    },

  ];
  BrandingMonthlypackages = [
    {
      packagename: 'IGNITE PRO',
      price: 39999,
      originalPrice: 49999,
      frequency: '/ Month',
    },
    {
      packagename: 'BOOST PRO',
      price: 25999,
      originalPrice: 49999,
      frequency: '/ Month',
    },
    {
      packagename: 'VIRAL PRO',
      price: 29999,
      originalPrice: 59999,
      frequency: '/ Month',
    },

  ];
  SocialYearlypackages = [
    {
      image: '/assets/ignite_icon.png',
      packagename: 'IGNITE',
      price: 4999,
      originalPrice: 11997,
      frequency: '/ Month',
    },
    {
      image:  '/assets/boost_icon.png',
      packagename: 'BOOST',
      price: 6499,
      originalPrice: 15997,
      frequency: '/ Month',
    },
    {
      image:'/assets/viral_icon.png',
      packagename: 'VIRAL',
      price: 7499,
      originalPrice: 17997,
      frequency: '/ Month',
    },

  ];
  BrandingYearlypackages = [
    {
      packagename: 'IGNITE',
      price: 599999,
      originalPrice: 699999,
      frequency: '/ Month',
    },
    {
      packagename: 'BOOST',
      price: 699999,
      originalPrice: 999999,
      frequency: '/ Month',
    },
    {
      packagename: 'VIRAL',
      price: 999999,
      originalPrice: 1999999,
      frequency: '/ Month',
    },

  ];
  SocialMonthlyContentofpacks = [
    {
      features: [
        '14 posts (alternate day)',
        '2 reels',
        '2 carrousels per month',
        'Basic customer support'
      ],
      description: 'The Ignite package is perfect for businesses just starting their journey into the digital world. This package offers essential content creation services to help you maintain a consistent online presence. Our AI-driven tools ensure your posts are timely and relevant, engaging your audience effectively.'
    },
    {
      features: [
        '22 posts (daily)',
        '4 reels (1 per week)',
        '4 carrousels (1 per week)',
        'In trend content',
        'Dedicated account manager'
      ],
      description: 'The Boost package is designed for businesses looking to significantly increase their online presence. With daily posts and a mix of reels and carrousels, your brand stays top-of-mind. Our AI features analyze market trends and optimize content for maximum impact, while a dedicated account manager ensures personalized service.'
    },
    {
      features: [
        '22 posts (daily)',
        '4 reels (1 per week)',
        '4 carrousels (1 per week)',
        'In trend content',
        'Dedicated account manager',
        'Trendy customised Song / Anthem'
      ],
      description: 'The Viral package is for businesses ready to go all-in on their digital marketing efforts. Beyond daily content and AI-optimized strategies, this package includes a customized song or anthem tailored to your brand. This package aims to make your brand viral, with a dedicated team working on your every need.'
    },

  ];
  BrandingMonthlyContentofpacks = [
    {
      features: [
        'Initial consultation,strategy & Basic brand identity with ​guidlines(logo, colors, typography)',
        '20 posts per month (Facebook,​Instagram, Twitter)4 reels per month (1 per week)2 carousels per month Basic graphics and content creation',
        '1 micro-influencer collaboration​(10k-50k followers)2 sponsored posts by the influencer Influencer selection and outreach',
        '2 customized songs',
        'Monthly performance reportBasic engagement metrics (likes, ​comments, shares)',
        'Website'
      ],
      description: 'The Ignite pro package is perfect for businesses just starting their journey into the digital world. This package offers essential content creation services to help you maintain a consistent online presence. Our AI-driven tools ensure your posts are timely and relevant, engaging your audience effectively.'
    },
    {
      features: [
        'Comprehensive strategy, positioning ​& advanced brand identity with detailed brand guidelines.',
        '30 posts per month (FB, Instagram,​Twitter, LinkedIn)6 reels per month, 3 carousels per ​month along with advanced graphics ​and content creation (animations)',
        '2 mid-tier influencers (50k-200k ​followers), 4 sponsored posts by ​influencers.',
        '6 customized songs',
        'Monthly ad spend management ​(budget excluded) Facebook, ​Instagram, and Google Ads setup and management',
        'Bi-weekly performance reports Advanced engagement metrics and ​insights, Campaign analysis and ​optimization recommendations',
        'Website'
      ],
      description: 'The Boost pro package is designed for businesses looking to significantly increase their online presence. With daily posts and a mix of reels and carrousels, your brand stays top-of-mind. Our AI features analyze market trends and optimize content for maximum impact, while a dedicated account manager ensures personalized service.'
    },
    {
      features: [
        'Full-scale strategy, including market ​research, Premium brand identity& ​Comprehensive brand guidelines ​document',
        '40 posts per month, 8 reels per ​month (2 per week) ,4 carousels per ​month, Premium graphics(high-​quality videos, animations,interactive content)',
        '2 mid-tier influencers (50k-200k ​followers), 4 sponsored posts by ​influencers.',
        '6 customized songs',
        'Monthly ad spend management ​(budget excluded) - Ads setup and ​management across multiple ​platforms (FB, IG, Google, LinkedIn) ​A/B testing and advanced targeting ​strategies',
        'Monthly webinars, Community ​management and wxclusive content ​for loyal followers and customers'
      ],
      description: 'The Viral pro package is for businesses ready to go all-in on their digital marketing efforts. Beyond daily content and AI-optimized strategies, this package includes a customized song or anthem tailored to your brand. This package aims to make your brand viral, with a dedicated team working on your every need.'
    },

  ];
  SocialyearlyContentofpacks = [
    {
      features: [
        '14 posts (alternate day)',
        '2 reels',
        '2 carrousels per month',
        'Basic customer support'
      ],
      description: 'The Ignite package is perfect for businesses just starting their journey into the digital world. This package offers essential content creation services to help you maintain a consistent online presence. Our AI-driven tools ensure your posts are timely and relevant, engaging your audience effectively.'
    },
    {
      features: [
        '22 posts (daily)',
        '4 reels (1 per week)',
        '4 carrousels (1 per week)',
        'In trend content',
        'Dedicated account manager'
      ],
      description: 'The Boost package is designed for businesses looking to significantly increase their online presence. With daily posts and a mix of reels and carrousels, your brand stays top-of-mind. Our AI features analyze market trends and optimize content for maximum impact, while a dedicated account manager ensures personalized service.'
    },
    {
      features: [
        '22 posts (daily)',
        '4 reels (1 per week)',
        '4 carrousels (1 per week)',
        'In trend content',
        'Dedicated account manager',
        'Trendy customised Song / Anthem'
      ],
      description: 'The Viral package is for businesses ready to go all-in on their digital marketing efforts. Beyond daily content and AI-optimized strategies, this package includes a customized song or anthem tailored to your brand. This package aims to make your brand viral, with a dedicated team working on your every need.'
    },

  ];
  package: any;
  ngOnInit(): void {
    this.indexofplan = 1;
    this.businessinfoid = localStorage.getItem("CheckBusinessInfoId");
    this.businessname = localStorage.getItem("SelectedBusinessInfoName");
    if(this.businessinfoid && this.businessname) {
      this.businessname = localStorage.getItem("SelectedBusinessInfoName");
    }
    this.Userid = localStorage.getItem('UserId');
    this.package = this.SocialMonthlypackages;
    this.changeofplans();
  }
  toggleVoucherSection() {
    this.isVoucherSectionOpen = !this.isVoucherSectionOpen;
  }
  openCouponDialog() {
    const dialogData = {};
    const dialogRef = this.dialog.open(ApplyCouponDialog, {
      height: '260px',
      width: '470px',
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe((result : any)=> {
      if (result) {
        this.handleCouponApplied(result);
      }
      else{
        this.toastr.error("No coupon applied");
      }
    });
  }
  handleCouponApplied(result: any) {
    if (result) {
      this.couponname = result.DiscountName;
      this.DiscountAmount = result.DiscountAmount; 
      this.AppliedCoupon = true; 
      this.isVoucherValid = true;
      this.isCoupon = true;
      this.totalAmount = +(this.selectedPlanPrice + this.gstAmount - this.DiscountAmount).toFixed(2);
      this.changeofplans();
      this.toastr.success(`Coupon applied successfully. Discount: ₹${this.DiscountAmount}`);
    } else {
      this.toastr.error('Failed to apply coupon.');
    }
  }
  
  ApplyCoupon() {
    this.service.CheckVoucherAvailibility(this.VoucherCode.value + "").subscribe(data => {
      if (data.Code == 200) {
        this.isCoupon = true;
        this.AppliedCoupon = true;
        const result  = {
          DiscountName : "voucher",
          DiscountAmount : data.Vouchers[0].VoucherValue,
        }
        this.handleCouponApplied(result);
        // this.totalAmount = +(this.selectedPlanPrice + this.gstAmount - this.DiscountAmount).toFixed(2);
      } else {
        this.toastr.error("Voucher is invalid or expired.");
      }
    });
  }
  
  changeofplans(){
    this.selectedPlan = this.package[this.selectedPlanIndex].packagename;
    this.selectedPlanPrice = this.package[this.selectedPlanIndex].price;
    if(this.AppliedCoupon){
      this.gstAmount = +((this.selectedPlanPrice-this.DiscountAmount) * 0.18).toFixed(2);
    this.totalAmount = +(this.selectedPlanPrice-this.DiscountAmount + this.gstAmount).toFixed(2);
    }
    else {
      this.gstAmount = +(this.selectedPlanPrice * 0.18).toFixed(2);
    this.totalAmount = +(this.selectedPlanPrice + this.gstAmount).toFixed(2);
    }
  }
  changesocial() {
    this.package = this.SocialMonthlypackages;
    this.changeofplans();
    if (this.isMonthly == true) {
      this.package = this.SocialYearlypackages;
      this.changeofplans();
    }
  }
  changebranding() {
    this.package = this.BrandingMonthlypackages;
    this.changeofplans();
    if (this.isMonthly == true) {
      this.package = this.BrandingYearlypackages;
      this.changeofplans();
    }
  }
  plandetails(index: number) {
    
    this.showfeatures = true;
    this.indexofplan = index;
    this.selectedPlanIndex = index;
    const selectedPlanData = this.package[index];
    this.changeofplans();
    
  }

  social() {
    this.package = this.SocialMonthlypackages;
    this.changeofplans();
    this.showfeatures = true;
    this.issocial = true;
    this.isbrand = false;
    this.package = this.isMonthly ? this.SocialYearlypackages : this.SocialMonthlypackages;
  }
   brand() {    
    this.toastr.error("Branding Plan is not currently available")
    // this.package = this.BrandingMonthlypackages;
    // this.changeofplans();
    // this.showfeatures = true;
    // this.isbrand = true;
    // this.issocial = false;
    // this.package = this.isMonthly ? this.BrandingYearlypackages : this.BrandingMonthlypackages;
  }
  buyProduct(amount : number,present_plan: any) {
    let details = {
     UserId : this.Userid,
     PlanName: present_plan,
     PlanType :present_plan,
     Amount : 1,
     TaxAmount: 0,
     DiscountAmount: 0,
     TotalAmount : amount,
     PlanDuration : "quaterly",
     PlanDurationDays : 30,
     PlanEndDate : new Date(),
     BusinessInfoId : this.businessinfoid,
     FirstName : 'Umesh',
     LastName : 'Guduru',
     Email : 'umesh.sachin95@gmail.com',
     MobileNumber : '8179091230',
    }
     this.service.payudata(details).subscribe(arg => {
         const product = arg.info;
         const paymentDetails = {
           payu_url: product.payu_url,
           first_name: product.first_name, 
           email: product.email,
           mobile: product.mobile, 
           callback_url: product.call_back_url, 
           payu_cancel_url: product.payu_cancel_url, 
           payu_fail_url: product.payu_fail_url, 
           payu_merchant_key: product.payu_merchant_key, 
           payu_sha_token: product.payu_sha_token, 
           txnid: product.txnId, 
           plan_name: product.plan_name, 
           amount: product.amount, 
           service_provider: product.service_provide
       };
       localStorage.setItem('paymentDetails', JSON.stringify(paymentDetails));
       setTimeout(() => {
       let paymentString = `
           <html>
             <body>
               <form action="${paymentDetails.payu_url}" method="post" id="payu_form">
                 <input type="hidden" name="firstname" value="${paymentDetails.first_name}"/>
                 <input type="hidden" name="email" value="${paymentDetails.email}"/>
                 <input type="hidden" name="phone" value="${paymentDetails.mobile}"/>
                 <input type="hidden" name="surl" value="${paymentDetails.callback_url}"/>
                 <input type="hidden" name="curl" value="${paymentDetails.payu_cancel_url}"/>
                 <input type="hidden" name="furl" value="${paymentDetails.payu_fail_url}"/>
                 <input type="hidden" name="key" value="${paymentDetails.payu_merchant_key}"/>
                 <input type="hidden" name="hash" value="${paymentDetails.payu_sha_token}"/>
                 <input type="hidden" name="txnid" value="${paymentDetails.txnid}"/>
                 <input type="hidden" name="productinfo" value="${paymentDetails.plan_name}"/>
                 <input type="hidden" name="amount" value="${paymentDetails.amount}"/>
                 <input type="hidden" name="service_provider" value="${paymentDetails.service_provider}"/>
                 <button type="submit" value="submit" #submitBtn></button>
               </form>
               <script type="text/javascript">document.getElementById("payu_form").submit();</script>
             </body>
           </html>`;
           
       const winUrl = URL.createObjectURL(
           new Blob([paymentString], { type: "text/html" })
       );
       
       window.location.href = winUrl;
     },2000)
       });   
   }
}
export interface ApplyCouponData{
  UserId : string;
  name : string;
}

@Component({
  selector: 'app-use-coupon',
  templateUrl: './apply-coupon-dialog.component.html',
  styleUrls: ['./apply-coupon-dialog.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ApplyCouponDialog{
  @Output() couponApplied = new EventEmitter<number>();
  @Output() voucherApplied = new EventEmitter<string>();
  @Output() offerApplied = new EventEmitter<number>();

  coupons : any;
  iscoupon: boolean = false;
  isVoucherValid: boolean = false;
  isOfferApplied: boolean = false;
  Appliedcoupon: boolean = false;
  AppliedVoucher: boolean = false;
  VoucherCode: string = '';
  offerCode: string = '';
  discountAmount = 0;
  PromoCodeData : PromoCode[] = [];

  constructor( public dialogRef: MatDialogRef<ApplyCouponDialog> , @Inject(MAT_DIALOG_DATA) public data: any,public service: SharkifyAiSerivceService,private toastr: ToastrService) {
  }
  totalAmount = this.data.totalamount;

  ngOnInit(){
    this.service.ActivePromoCodes().subscribe(data => {
      if (data.Code == 200) {
        this.PromoCodeData=data.PromoCodes;

      } else {
      }
    });


  }
  
  applyVoucher() {
    if (this.isVoucherValid) {
      this.toastr.error('A voucher is already applied.');
      return;
    }

    if (this.iscoupon) {
      this.toastr.error('Cannot apply voucher. A coupon is already applied.');
      return;
    }

    if (this.VoucherCode === 'VALID_VOUCHER_CODE') {
      this.isVoucherValid = true;
      this.voucherApplied.emit(this.VoucherCode);
      this.toastr.success('Voucher applied successfully.');
    } else {
      this.isVoucherValid = false;
      this.toastr.error('Invalid voucher code.');
    }
  }

  addCouponToTheAmount(i: number) {
    if (this.isVoucherValid) {
      this.toastr.error('Cannot apply coupon. A voucher is already applied.');
      return;
    }

    this.Appliedcoupon = !this.Appliedcoupon;
    if (this.Appliedcoupon) {
      const discount = this.coupons[i].CouponCod;
      const Percentage = this.coupons[i].Percentage;
      this.iscoupon = true;
      this.toastr.success(`Coupon applied: ${discount} (${Percentage} class).`);
    } else {
      this.iscoupon = false;
      this.toastr.success('Coupon removed.');
    }
  }
  onNoClick(): void {
    this.dialogRef.close({SelectionType : "No"});
  }
  applyOffer(couponId: number) {
    if (this.isOfferApplied) {
      this.toastr.error('An offer is already applied.');
      return;
    }
    if (this.iscoupon || this.isVoucherValid) {
      this.toastr.error('Cannot apply offer. A coupon or voucher is already applied.');
      return;
    }
    const offerDetails = {
      offerCode: 'VALID_OFFER_CODE',
      CouponType: this.coupons[couponId].CouponType, 
      offerValue: this.coupons[couponId].value ?? 0,
    };
  
    if (offerDetails.CouponType === 'Percentage Off') {
      offerDetails.offerValue = this.coupons[couponId].Percentage;
      this.discountAmount = this.totalAmount * (offerDetails.offerValue / 100);
    } else if (offerDetails.CouponType === 'das') {
      this.discountAmount = offerDetails.offerValue;
    }
  
    if (offerDetails.offerCode === 'VALID_OFFER_CODE') {
      const name = this.coupons[couponId].CouponCode;
      this.isOfferApplied = true;
      this.toastr.success(`Offer applied successfully: ${this.discountAmount} off`);
      this.dialogRef.close({ DiscountAmount : this.discountAmount, DiscountName : name});
    } else {
      this.isOfferApplied = false;
      this.toastr.error('Invalid offer code.');
      this.dialogRef.close(null); 
    }
  }
}
